import React, { useState, useEffect } from "react";
import Dashboard from "../startupdashboard/admin_dashboard";
import axios from "axios";
import CaHeader from "./CaHeader";
import CaSidebar from "./CaSidebar";

export default function CaMainDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [fullName, setFullName] = useState("");

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const startupId = localStorage.getItem("startupId");
        const response = await axios.get(
          `${process.env.NEXT_PUBLIC_API_URL}/api/startups/${startupId}`
        );
        setFullName(response.data.fullName);
      } catch (error) {
        console.error("Error fetching fullName:", error);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <CaSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />

      {/* Main Content */}
      <div
        className={`flex flex-col flex-1 transition-all duration-300 ${
          !isMobile ? (sidebarOpen ? "ml-64" : "ml-16") : "ml-0"
        }`}
      >
        {/* Header: now rendered via the new Header component */}
        <CaHeader
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
          fullName={fullName}
        />

        {/* Dynamic Page Content */}
        <div className="flex-1 p-6 overflow-y-auto">
          <Dashboard />
        </div>
      </div>
    </div>
  );
}
